// extracted by mini-css-extract-plugin
export var noSpinners = "_t1-6";
export var percentageInput = "_t1-7";
export var variantColor1 = "_t1-0";
export var variantColor2 = "_t1-1";
export var variantColor3 = "_t1-2";
export var variantColor4 = "_t1-3";
export var variantColor5 = "_t1-4";
export var variantColor6 = "_t1-5";